<template>
	<div class="omapi-personalization__rule">
		<h4 :ref="rule.id + '-title'" class="omapi-personalization__rule-name">
			{{ rule.friendlyText }}
			<div class="omapi-personalization__rule-add">
				<svg-plus-circle />
				<div class="omapi-personalization__rule-create">
					<core-button v-if="ruleAllowed" color="blue" size="small" type="primary" router-to="templates">
						Create Campaign
					</core-button>
					<core-upgrade-button
						v-else
						color="green"
						size="small"
						type="primary"
						utm-medium="Personalization"
						:features="[rule.id]"
					>
						Get This Feature
					</core-upgrade-button>
					<core-button
						target="_blank"
						:link-style="true"
						:href="rule.helpUrl + '?utm_source=WordPress&utm_campaign=Plugin&utm_medium=Personalization'"
						class="omapi-link-arrow-after"
						>Learn More</core-button
					>
				</div>
			</div>
		</h4>

		<div class="omapi-personalization__rule-desc">{{ rule.helpText }}</div>
	</div>
</template>

<script>
export default {
	props: {
		rule: {
			required: true,
			type: Object,
		},
	},
	computed: {
		ruleAllowed() {
			return this.$store.getters.hasRuleType(this.rule.id);
		},
	},
};
</script>
